import { RouteEnum } from 'pro/config/routers';
import { generatePath } from 'ava-util/dist/request';
import dynamic from 'next/dynamic';
import { IHelpConfig, IHelpGroupConfig } from 'mod/help/interface';
import { WHOLESALE_ROOT_MAP } from 'base/config/constant'

const envName = (process.env.NEXT_PUBLIC_ENV_NAME || 'prod')

export const helpPages: IHelpConfig['pages'] = {
    'contact-us': {
        title: 'web_help_contact_us',
        content: {
            en: dynamic(() => import('@pro/help/ContactUs/EN')),
            de: dynamic(() => import('@pro/help/ContactUs/DE')),
        },
    },
    'return-policy': {
        title: 'web_help_return_policy',
        content: {
            en: dynamic(() => import('@pro/help/ReturnPolicy/EN')),
            de: dynamic(() => import('@pro/help/ReturnPolicy/DE')),
        },
    },
    'shipping-types': {
        title: 'web_help_shipping_types',
        content: {
            en: dynamic(() => import('@pro/help/ShippingTypes/EN')),
            de: dynamic(() => import('@pro/help/ShippingTypes/DE')),
        },
    },
    'wrong-item-received': {
        title: 'web_help_wrong_item_received',
        content: {
            en: dynamic(() => import('@pro/help/WrongItemReceived/EN')),
            de: dynamic(() => import('@pro/help/WrongItemReceived/DE')),
        },
    },
    'item-lost-in-transit': {
        title: 'web_help_item_lost_in_transit',
        content: {
            en: dynamic(() => import('@pro/help/ItemLostInTransit/EN')),
            de: dynamic(() => import('@pro/help/ItemLostInTransit/DE')),
        },
    },
    'about-points': {
        title: 'web_help_about_points',
        content: {
            en: dynamic(() => import('@pro/help/AboutPoints/EN')),
            de: dynamic(() => import('@pro/help/AboutPoints/DE')),
        },
    },
    'about-vdays': {
        title: 'web_help_about_vdays',
        content: {
            en: dynamic(() => import('@pro/help/AboutVDays/EN')),
            de: dynamic(() => import('@pro/help/AboutVDays/DE')),
        },
    },
    'about-us': {
        title: 'web_help_about_us',
        content: {
            en: dynamic(() => import('@pro/help/AboutUs/EN')),
            de: dynamic(() => import('@pro/help/AboutUs/DE')),
        }
    },
    'fraud-awareness': {
        title: 'web_help_fraud_awareness',
        content: {
            en: dynamic(() => import('@pro/help/FraudAwareness/EN')),
            de: dynamic(() => import('@pro/help/FraudAwareness/DE')),
        },
    },
    'privacy-policy': {
        title: 'web_help_privacy_policy',
        content: {
            en: dynamic(() => import('@pro/help/PrivacyPolicy/EN')),
            de: dynamic(() => import('@pro/help/PrivacyPolicy/DE')),
        },
    },
    'terms-of-service': {
        title: 'web_help_terms_of_service',
        content: {
            en: dynamic(() => import('@pro/help/TermsOfService/EN')),
            de: dynamic(() => import('@pro/help/TermsOfService/DE')),
        },
    },
    'intellectual-property': {
        title: 'web_help_intellectual_property',
        content: {
            en: dynamic(() => import('@pro/help/Patent/EN')),
            de: dynamic(() => import('@pro/help/Patent/DE')),
        },
    },
    'about-diy-pools': {
        title: 'web_help_about_diy_pools',
        content: {
            en: dynamic(() => import('@pro/help/AboutDiyPools/EN')),
            de: dynamic(() => import('@pro/help/AboutDiyPools/DE')),
        },
    },
    'about-diy-ranking': {
        title: 'web_help_about_diy_ranking',
        content: {
            en: dynamic(() => import('@pro/help/AboutDiyRanking/EN')),
            de: dynamic(() => import('@pro/help/AboutDiyRanking/DE')),
        },
    },
    'add-device': {
        title: 'web_help_add_device',
        content: {
            en: dynamic(() => import('@pro/help/AddDevice/AddDevice/EN')),
            de: dynamic(() => import('@pro/help/AddDevice/AddDevice/DE')),
        },
    },
    'add-growhub-e42-e42a': {
        title: 'web_help_growhub_e42',
        content: {
            en: dynamic(() => import('@pro/help/AddDevice/AddGrowHubE42E42a/EN')),
            de: dynamic(() => import('@pro/help/AddDevice/AddGrowHubE42E42a/DE')),
        },
    },
    'add-growhub-e25': {
        title: 'web_help_growhub_e25',
        content: {
            en: dynamic(() => import('@pro/help/AddDevice/AddGrowHubE25/EN')),
            de: dynamic(() => import('@pro/help/AddDevice/AddGrowHubE25/DE')),
        },
    },
    'impressum': {
        title: 'web_help_legal_notice',
        content: {
            en: dynamic(() => import('@pro/help/LegalNotice/EN')),
            de: dynamic(() => import('@pro/help/LegalNotice/DE')),
        },
    },
};

const helpGroups: IHelpGroupConfig[] = [
    {
        key: 'service',
        title: 'web_help_customer_service_title',
        list: [
            'contact-us',
            'return-policy',
            'shipping-types',
            'wrong-item-received',
            'item-lost-in-transit',
            'about-points',
            'about-vdays',
        ]
    },
    {
        key: 'company',
        title: 'web_footer_link_company',
        list: [
            // { code: 'about-us', condition: 'showAboutUs' },
            { title: 'web_shop_brand_story', link: RouteEnum.BRAND_STORY },
            'fraud-awareness',
            'privacy-policy',
            'terms-of-service',
            { code: 'impressum', condition: 'countryDE' },
            { title: 'web_help_blog', link: RouteEnum.BLOG, condition: 'showEnBlog' },
            { title: 'web_help_blog', link: RouteEnum.BLOG_DE, condition: 'countryDE' },
            'intellectual-property',
            { title: 'web_help_referral_program', link: RouteEnum.REFERRAL, condition: 'showReferrer' },
            { title: 'web_affiliate_program', link: RouteEnum.AFFILIATE },
            { title: 'web_shop_tester_club', link: RouteEnum.TesterClub },
            {
                title: 'web_wholesale_become_a_reseller',
                link: `${WHOLESALE_ROOT_MAP[envName]}become-a-reseller`,
                linkProps: {target: '_blank'}
            },
        ]
    },
    {
        key: 'account',
        title: 'web_footer_link_account',
        list: [
            { title: 'web_footer_link_my_account', link: RouteEnum.ORDERS },
            { title: 'web_footer_link_log_in', link: RouteEnum.LOGIN },
            { title: 'web_footer_link_create_account', link: generatePath(RouteEnum.LOGIN, { target: 'register' }) },
            { title: 'web_footer_link_order_history', link: RouteEnum.ORDERS },
            { title: 'web_footer_link_my_addresses', link: RouteEnum.ADDRESS_BOOK },
        ]
    },
];

export const helpConfig: IHelpConfig = {
    pages: helpPages,
    groups: helpGroups,
};